// 質問のプルダウン開閉

const openQuestion = (categoryName, index) => {
  const body = document.getElementById(categoryName + "-" + index + "-body");
  const answer = document.getElementById(
    categoryName + "-" + index + "-answer"
  );
  const toggleButton = document.getElementById(categoryName + "-" + index);
  const arrow = toggleButton.querySelector("div");

  if (answer.classList.contains("visible")) {
    body.classList.remove("selected_question_body");
    answer.classList.remove("visible");
    arrow.classList.add("arrow-bottom");
    arrow.classList.remove("arrow-up");
  } else {
    body.classList.add("selected_question_body");
    answer.classList.add("visible");
    arrow.classList.remove("arrow-bottom");
    arrow.classList.add("arrow-up");
  }
};

// URLを抽出してaタグ化
const getLinkAndATag = () => {
  const answers = document.querySelectorAll(".answer-content");
  for (const answer of answers) {
    for (const p of answer.childNodes) {
      const link = p.textContent.match(
        /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+/g
      );
      if (link) {
        const newLink = "<a href='" + link + "'>" + link + "</a>";
        p.innerHTML = p.innerHTML.replace(link, newLink);
      }
    }
  }
};
// 矢印画像をJSで挿入
// const toggleButtonsFunc = () => {
//   const toggleButtons = document.querySelectorAll(".toggleButton");

//   for (const button of toggleButtons) {
//     button.textContent = "＋";
//   }
// };
window.openQuestion = openQuestion;
getLinkAndATag();
// toggleButtonsFunc();
